<script setup>
import { inject, computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    required: true
  }
})

const close = inject('close')

const urlToFile = computed(() => {
  if (props.message.attachment?.mediaType === 'image') {
    return props.message.attachment.fields?.links.original || null
  }
  else if (props.message.attachment?.mediaType === 'video') {
    return props.message.attachment.fields?.videoUrl || null
  }

  return null
})
</script>

<template>
  <a
    v-if="urlToFile"
    :href="urlToFile"
    target="_blank"
    role="menuitem"
    class="flex items-center gap-2.5 px-1 py-3 w-full text-left"
    @click="close">
    <InlineSvg :src="require('@/assets/fontawesome/regular/arrow-down-to-line.svg')" class="w-4 h-4 shrink-0"/>

    {{ message.attachment?.mediaType === 'image' ? $t('common.save_image') : $t('common.save_video') }}
  </a>
</template>